import { graphql } from '@apollo/client/react/hoc';
import * as _ from 'lodash-es';
import qs from 'qs';
import { withRouter } from 'react-router-dom';
import { branch, compose, withProps } from 'recompose';
import CURRENT_USER_QUERY from './CURRENT_USER_QUERY';
import { RoleEnum } from '../../shared/role-enum';

/**
 * ! MIGRATION NOTE
 *
 * This is used in a bunch of older places so be careful when updating. If you're able
 * to de-compose, do it!
 */

const withCurrentUser = () => WrappedComponent =>
  compose(
    withRouter,
    graphql(CURRENT_USER_QUERY, {
      options: {
        fetchPolicy: 'network-only',
      },
      props: ({ data: { loading, currentUser, organizations } }) => ({
        loading,
        currentUser,
        organizations,
      }),
    }),
    branch(
      ({ loading }) => loading,
      () => () => null
    ),
    withProps(props => {
      const { currentUser, history, organizations, loading } = props;

      if (!loading && !currentUser)
        return {
          isAuthenticated: false,
        };

      const query = qs.parse(_.get(history, 'location.search'), { ignoreQueryPrefix: true });

      const roles = currentUser.roles.map(({ role }) => role);

      const permissionedOrganizations = currentUser.organization_admins.map(
        o => o.organizationByOrganization._id
      );

      /** @type {string | undefined}  */
      let organizationId = permissionedOrganizations[0];

      if (roles.includes(RoleEnum.ADMIN)) {
        // Some ADMINs don't have accurate organization_admins data.
        // Default to their home organization, or first admin org, or first organization.
        organizationId =
          currentUser.home_organization ?? permissionedOrganizations[0] ?? organizations[0]?._id;
      } else if (roles.includes(RoleEnum.OWNER)) {
        organizationId =
          currentUser.home_organization &&
          permissionedOrganizations.includes(currentUser.home_organization)
            ? currentUser.home_organization
            : permissionedOrganizations[0];
      }

      const queryOrgId = query?.organization;

      if (queryOrgId) {
        // city admin
        if (roles.includes(RoleEnum.OWNER) && permissionedOrganizations.includes(queryOrgId)) {
          organizationId = queryOrgId;
        }
        // super admin
        if (roles.includes(RoleEnum.ADMIN)) {
          organizationId = queryOrgId;
        }
      }

      return {
        currentUser: {
          ...currentUser,
          organizationId,
        },
        /** Org ID from query params, with a fallback to first city in user's organization_admins */
        organizationId,
        organizations,
        isAuthenticated: !!currentUser,
        roles: currentUser.roles,
      };
    })
  )(WrappedComponent);

export default withCurrentUser;
